/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { useState } from "react";
import { FaUnlock } from "react-icons/fa";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ContactApi } from "../../../api/Contacts";
import contact from "../../../assets/images/contact";
import {
  ContactFilterAtom,
  IsCheckedAllContactsAtom,
} from "../../../atoms/ContactFilterAtom";
import { ContactFiltersAtom } from "../../../atoms/ContactFiltersAtom";
import { ContactsAtom } from "../../../atoms/ContactsAtom";
import { ContactStatus } from "../../../generated/Api";
import modal from "../../../pages/modal";
import { IContact } from "../../../types/Contact";
import { useModal } from "../Modal";
import Warning from "./Warning";

interface Props {
  suppressedContacts: IContact[];
}

export function UnsuppressContactModal(props: Props) {
  const { suppressedContacts } = props;

  const setContacts = useSetRecoilState(ContactsAtom);
  const selectAll = useRecoilValue(IsCheckedAllContactsAtom);
  const contactFilter = useRecoilValue(ContactFilterAtom);
  const contactFilters = useRecoilValue(ContactFiltersAtom);
  const [isLoading, setIsLoading] = useState(false);

  const modal = useModal();

  return (
    <Warning
      fontAwesomeIcon={() => (
        <div
          css={css`
            background-color: #70707080;
            border-radius: 50%;
            width: 80px;
            height: 80px;
            padding: 20px;
            display: flex;
            justify-content: center;
            align-items: center;

            margin-bottom: 16px;
          `}
        >
          <FaUnlock
            style={{
              color: "white",
            }}
            size={32}
          />
        </div>
      )}
      title="Unsuppress"
      description={
        suppressedContacts.length === 1
          ? `Are you sure you want unsuppress this contact?`
          : `Are you sure you want to unsuppress the selected contacts which are suppressed?`
      }
      buttonsName={["No", "Yes"]}
      onOkClicked={async () => {
        let response;
        setIsLoading(true);
        if (selectAll) {
          response = await ContactApi.manyAdminUnsuppress({
            query: {
              ...contactFilters,
              tagQuery: contactFilter?.tagQuery,
            },
          });
        } else {
          response = await ContactApi.manyAdminUnsuppress({
            contactIds: suppressedContacts.map((c) => c._id),
          });
        }

        setIsLoading(true);

        if (response) {
          setContacts(
            (contacts) =>
              contacts &&
              contacts.map((c) => {
                if (
                  c.status === ContactStatus.SUPRESSED &&
                  suppressedContacts.find((sc) => sc._id === c._id)
                )
                  return {
                    ...c,
                    status: ContactStatus.NOT_CONFIRMED,
                  };
                else return c;
              })
          );
        }
        modal.popModal();
      }}
      onCancelClicked={() => {
        modal.popModal();
      }}
    />
  );
}
